<template>
  <div class='CardType'>
    <search-form size='medium'
                 :searchData="search.searchData"
                 :searchForm="search.searchForm"
                 :searchHandle="search.searchHandle">
    </search-form>

    <Table :TableParam="Table">
      <template v-slot:handle="row">
        <el-link type="primary"
                 @click="changeItem(row.item)">编辑</el-link>
        <el-divider direction="vertical"></el-divider>
        <el-link type="danger"
                 @click="removeItem(row.item)">删除</el-link>
      </template>
      <template v-slot:Paging>
        <Paging @change="getItemList"
                :pager="pager" />
      </template>
    </Table>

    <service-dialog :show.sync="listDialog.show"
                    @handle="listDialog.confirm"
                    :title="listDialog.title">
      <template v-slot:dialogContent>
        <div class="content">
          <div class="floor">
            <!-- <el-tabs v-model="listDialog.floorName"
                     @tab-click="cutFloor">
              <el-tab-pane v-for="floor in listDialog.floorData"
                           :key="floor.name"
                           :label="floor.name"
                           :name="floor.name"> -->
                <div class="floorlist">
                  <ul>
                    <li 
                      v-for="floor in listDialog.floorData" 
                      :class="floor.name === listDialog.floorName ? 'active' : ''" 
                      @click="cutFloor(floor)"
                      :key="floor.name">
                      {{ floor.name }}
                      </li>
                    </ul>
                </div>
                <div class="storeFormat">
                  <span
                    v-for="storeFormatItem in storeFormat" 
                    :key="storeFormatItem.name" 
                    @click.stop="storeFormatChange(storeFormatItem.name)"
                    :class="{storeFormatActive:storeFormatActive===storeFormatItem.name}">
                      {{storeFormatItem.name}}
                  </span>
                  <div class="storeName">
                    <span>搜索店铺：</span>
                    <el-input
                      style="width: 165px;"
                      placeholder="输入店铺号或名称"
                      clearable
                      @keyup.enter.native="storeSearch"
                      v-model="storeName">
                    </el-input>
                  </div>
                </div>
                <div class="selectAll" v-if="listDialog.shopData.length>0 && storeFormatActive==='全部'">
                  <!-- -->
                  <el-checkbox @change="(value)=>handleCheckAllChange(value,listDialog.floorName)"
                               v-model="listDialog.floorCheckAll[`${listDialog.floorName}`]">全部选择</el-checkbox>
                </div>
                <div class="selectFloor" v-if="listDialog.shopData.length>0">
                  <el-checkbox-group v-model="listDialog.checkedShops[`${listDialog.floorName}`]"
                                     @change="(value)=>handleCheckedCitiesChange(value,listDialog.floorName)">
                    <el-checkbox v-for="shop in listDialog.shopData"
                                 :label="shop.id"
                                 :key="shop.id">
                                 <span :title="shop.shopName" class="textOverflow">
                                   {{shop.shopName}}
                                   <div style="overflow: hidden;text-overflow: ellipsis;" :title="shop.shopCode">{{shop.shopCode}}</div>
                                 </span>
                    </el-checkbox>
                  </el-checkbox-group>
                </div>
                 <div class="selectFloor" v-if="listDialog.shopData.length===0">
                  暂无数据
                 </div>
              <!-- </el-tab-pane>
            </el-tabs> -->
          </div>
        </div>
      </template>
    </service-dialog>

    <service-dialog :show.sync="addDialog.show"
                    @handle="addDialog.confirm"
                    :title="addDialog.title">
      <template v-slot:dialogContent>
        <div class="addfrom">
          <el-form label-position="right"
                   label-width="120px"
                   :model="addDialog.addFrom">
            <el-form-item label="账户类型名称："
                          prop="cardName">
              <el-input v-model="addDialog.addFrom.cardName"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </template>
    </service-dialog>
    <service-dialog :show.sync="setDialog.show"
                    :title="setDialog.title"
                    :isFooter="false">
      <template v-slot:dialogContent>
        <div class="head">
          <div>剩余授权额度：{{ setDialog.form.remainingAmount }}元</div>
          <div>
            <span>总授信额度：{{ setDialog.form.totalAmount }}元</span>
            <span>已用授信额度：{{ setDialog.form.expenditureAmount }}元</span>
          </div>
        </div>
        <div class="input">
          <el-input type="number" v-model="setDialog.form.amount" placeholder="请输入" size="small"></el-input>
          <el-button type="primary" size="small" style="margin: 0 5px" @click="adjustFun">调整</el-button>
        </div>
        <el-table :data="setDialog.tableData" style="width: 100%; max-height: 420px; overflow-y: auto">
          <el-table-column prop="updateDate" label="调整时间"></el-table-column>
          <el-table-column prop="adjustAmount" label="调整金额"></el-table-column>
          <el-table-column prop="updater" label="调整人员"></el-table-column>
        </el-table>
      </template>
    </service-dialog>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import SearchForm from '@/components/SearchForm'
import Table from '@/components/Table'
import serviceDialog from '@/components/Dialog'
import Paging from '@/components/Paging'
import { handleCofirm } from '@/utils'
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    SearchForm,
    Table,
    Paging,
    serviceDialog
  },
  data () {
    // 这里存放数据
    return {
      asyncData: { // 接口请求回来的数据
        floorShops: []
      },

      storeName:'',
      listDialog: { // 适用店铺
          show: false,
          title: '店铺',
          confirm: this.bindShops,
          floorName: '全部', // 选中的楼层
          floorCheckAll: {}, // 单楼层是否全部选中
          floorData: [], // 楼层数据
          shopData: [], // 店铺数据
          checkedShops: {} // 选中的数据
        },
      storeFormatActive: '全部',
      storeFormat:[
        { name: '零售'},
        { name: '餐饮'},
        { name: '文娱'},
        { name: '服务'},
        { name: '其他'},
        { name: '全部'},
      ],
      pager: { // 翻页
        page: 1,
        rows: 10,
        count: 0
      },

      search: { // 搜索
        searchData: {
          interst: []
        }, // 返回的数据
        searchForm: [
          { type: 'Input', label: '名称：', prop: 'name', placeholder: '请输入名称' },
          {}
        ],
        searchHandle: [
          { label: '查询', type: 'primary', handle: () => this.searchHandleForm() }
        ]
      },
      Table: { // 表格
        primaryBtn: {
          show: false,
          html: '<i class="el-icon-plus"></i>新建',
          handle: () => { this.addDialog.title = '新建'; this.addDialog.show = true; this.addDialog.addFrom.cardName = '' }
        },
        handle: true,
        data: [],
        column: [
          { prop: 'id', label: '编号' },
          { prop: 'name', label: '名称' },
          { prop: 'updateDate', label: '更新时间' },
          { prop: 'creator', label: '更新人' },
          {
            prop: 'showShop',
            label: '适用店铺',
            type: 'event',
            handle: (row) => {
              this.listDialog.show = true
              this.bindShopsId = row.id
              this.echoCardApplyShops(row.shopIds)
            }
          },
        ]

      },

      addDialog: { // 新建
        show: false,
        title: '新建',
        confirm: () => this.addFixType(),
        addFrom: {
          cardName: null
        }
      },
      setDialog: { // 设置
        show: false,
        title: '调整',
        form: {
          expenditureAmount: '',
          remainingAmount: '',
          totalAmount: '',
          id: null
        },
        tableData: []
      }
    }
  },
  computed: {
    _isAdmin () {
      const userInfoVO = JSON.parse(localStorage.getItem('userInfo') || '{}')?.userInfoVO
      return userInfoVO && (userInfoVO.admin || userInfoVO.superAdmin)
    }
  },
  watch: {
    'listDialog.show': {
      handler (to) {
        // this.storeFormatActive = '全部'
        this.cutFloor()
        this.storeName=''
      }
    }
  },
  // 方法集合
  methods: {
    // 切换行业
    storeFormatChange(name) {
      this.storeName=''
      this.storeFormatActive=name
      this.changeFloorCheckData(name)
    },
    // 回显当前使用店铺
    echoCardApplyShops (shopIds) {
      const floorShops = this.asyncData.floorShops
      const ids = (shopIds && shopIds.length) ? shopIds.map(item => String(item)) : []
      floorShops.forEach(e => {
        this.listDialog.checkedShops[e.floor] = []
        this.listDialog.floorCheckAll[e.floor] = false
        ids.forEach(id => {
          const idx = e.shops.findIndex(s => s.id == id)
          if (idx !== -1) {
            this.listDialog.checkedShops[e.floor].push(id)
          }
        })
        this.listDialog.floorCheckAll[e.floor] = this.listDialog.checkedShops[e.floor].length === e.shops.length
      })
      this.otherCheckeFn()
    },

    // 筛选所属行业数据
    changeFloorCheckData(name){
      const floorName = this.listDialog.floorName
      const floorShops = this.asyncData.floorShops
      floorShops.forEach((item) => {
        if (item.floor === floorName) { 
            this.listDialog.shopData = item.shops
          }
        })
      if(name==='全部'){
        this.listDialog.floorCheckAll[floorName] = this.listDialog.checkedShops[floorName].length === this.listDialog.shopData.length
      }else{
        this.listDialog.shopData = this.listDialog.shopData.filter(item=>{
            return item.businessName === name
        })
      }
    },

    // 商店搜索
    storeSearch () {
      if(this.storeName!==''){
         this.changeFloorCheckData(this.storeFormatActive)
         this.listDialog.shopData = this.listDialog.shopData.filter(item=>{
            return (item.shopName.indexOf(this.storeName) !==-1) || (item.shopCode.indexOf(this.storeName) !==-1) || (this.storeName.indexOf(item.shopName) !== -1) || (this.storeName.indexOf(item.shopCode) !==-1)
          })
      }else{
        this.changeFloorCheckData(this.storeFormatActive)
      }
    },
     // 点击切换楼层
     cutFloor (val = {name: '全部'}) {
      this.listDialog.floorName = val.name
      const floorName = this.listDialog.floorName
      const floorShops = this.asyncData.floorShops

      floorShops.forEach((item) => {
        if (item.floor === floorName) {
          this.listDialog.shopData = item.shops
        }
      })
      this.storeName = ''
      this.storeFormatActive = '全部'
    },
    // 每次选择，判断是否全选
    handleCheckedCitiesChange (value, floorName) {
      if(floorName!=='全部'){
        this.otherCheckeFn()
      }else{
        this.allCheckeFn(value)
      }
      const checkedCount = value.length
      this.listDialog.floorCheckAll[floorName] = checkedCount === this.listDialog.shopData.length
    },

    allCheckeFn(value){
      for(let i in this.listDialog.checkedShops){
        if(i!=='全部'){
          this.listDialog.checkedShops[i] = []
        }
      }
      if(value.length==0){
        for(let i in this.listDialog.checkedShops){
        if(i!=='全部'){
            this.listDialog.floorCheckAll[i] = false
          }
        }
      }
      value.forEach(item=>{
        this.asyncData.floorShops.forEach(element => {
          element.shops.forEach(item2=>{
            if(item2.id == item){
              this.listDialog.checkedShops[element.floor] = [...new Set(this.listDialog.checkedShops[element.floor].concat(item))]
              this.listDialog.floorCheckAll[element.floor] = this.listDialog.checkedShops[element.floor].length === element.shops.length
            }
          })
        })
      })
    },
    otherCheckeFn(){
      this.listDialog.checkedShops['全部'] = []
        for(let i in this.listDialog.checkedShops){
          if(i!=='全部'){
            this.listDialog.checkedShops['全部'] = this.listDialog.checkedShops['全部'].concat(this.listDialog.checkedShops[i])
            this.asyncData.floorShops.forEach(element => {
              if(element.floor == '全部'){
                this.listDialog.floorCheckAll[element.floor] = this.listDialog.checkedShops[element.floor].length === element.shops.length
              }
            })
          }
        }
    },
    // 点击全选按钮
    handleCheckAllChange (val, floorName) {
      const shopNames = this.listDialog.shopData.map((item) => item.id)
      this.listDialog.checkedShops[floorName] = val ? shopNames : []
      if(floorName!=='全部'){
        this.otherCheckeFn()
      }else{
        if(val){
          this.allCheckeFn(shopNames)
        }else{
          this.allCheckeFn([])
        }
      }
    },
    // 点击绑定店铺确定按钮
    async bindShops () {
      const { bindShopsId, listDialog } = this
      const floorShopBindParams = Object.keys(listDialog.checkedShops).map((item) => {
        if(item!=='全部'){
          if (listDialog.checkedShops[item].length) {
            return {
              shopIds: listDialog.checkedShops[item]
            }
          }
        }
      }).filter(Boolean)
      const params = {
        id: bindShopsId,
        floorShopBindParams
      }
      await this.handleBindStore(params)
      await this.searchHandleForm()
      this.listDialog.show = false
    },

      // 绑定店铺接口
      async handleBindStore (params) {
      await this.$http.handleBindStore(params)
        .then((res) => {
          if (res.status === 200) {
            this.$message.success('绑定成功')
          }
        })
    },
    // 获取楼层店铺
    // 初始化事件
    getFloorShopList () {
      this.$http.getFloorShopList()
        .then((res) => {
          if (res.status === 200) {
            let allShops = []   
            res.data.forEach(item=>{
              allShops = allShops.concat(item.shops)
            })
            this.asyncData.floorShops = res.data.concat({floor: '全部', shops: allShops})
            this.listDialog.floorName = '全部' //res.data[0].floor
            this.asyncData.floorShops.forEach((item) => {
              if (item.floor === this.listDialog.floorName) {
                this.listDialog.shopData = item.shops
              }
              this.listDialog.floorData.push({ name: item.floor })
              const floorName = item.floor
              this.$set(this.listDialog.checkedShops, floorName, [])
              this.$set(this.listDialog.floorCheckAll, floorName, false)
            })
          }
        })
    },
    searchHandleForm () {
      this.getItemList()
    },
    removeItem (row) { // 删除行
      handleCofirm('确定要删除该行嘛?', 'type')
        .then(async () => {
          this.deleteCardType(row.id)
        })
        .catch(() => { })
    },

    async changeItem (row) { // 修改行
      await this.getCardTypeInfo(row.id)
      const { cardTypeInfo } = this
      if (cardTypeInfo.name !== row.name) {
        this.$message.warning('该条信息不是最新的,即将刷新列表')
        this.getItemList()
      } else {
        this.typeId = row.id
        this.addDialog.addFrom.cardName = row.name
        this.addDialog.title = '编辑'
        this.addDialog.show = true
      }
    },
    // 是否启用授信开关
    changeEmpowerFun (e, id) {
      this.$http.enableCardCreditApi({ cardId: id, enable: e }).then(res => {
        this.getItemList()
      })
    },
    async setFun ({ id }) {
      const res = await this.getDetail(id)
      const list = await this.$http.detailCreditApi({ id }).then(res => res.data)
      if(res) {
        const { expenditureAmount, remainingAmount, totalAmount } = res
        this.setDialog.tableData = list || []
        this.setDialog.form = {
          expenditureAmount,
          remainingAmount,
          totalAmount,
          id
        }
        this.setDialog.show = true
      }
    },
    // 调整
    adjustFun () {
      const { form } = this.setDialog
      if(!form.amount) return this.$message.warning('请输入调整数')
      const data = {
        id: form.id,
        amount: form.amount
      }
      this.$http.adjustCardCreditApi(data).then(res => {
        if(res.status === 200) {
          this.$message.success('调整成功')
          this.getItemList()
          this.setDialog.show = false
        }
      })
    },
    deleteCardType (id) {
      const params = {
        id
      }
      this.$http.deleteCardType(params)
        .then((res) => {
          if (res.status === 200) {
            this.$message.success(res.msg)
            this.getItemList()
          }
        })
    },

    getItemList () {
      const { pager, search } = this
      const param = {
        pageNum: pager.page,
        pageSize: pager.rows,
        ...search.searchData
      }
      this.$http.getCardTypePageList(param)
        .then((res) => {
          this.Table.data = res.data.list.map((item) => ({
              ...item,
              showShop: (item.shopIds && item.shopIds.length) ? `已设置${item.shopIds.length}` : '未设置',
            }))
          pager.count = res.data.total
        })
    },

    addFixType () {
      const { cardName } = this.addDialog.addFrom
      if((cardName.trim()) === ''){
        this.$message({
          message: '账户类型名称不能为空!',
          type: 'warning'
        });
        return
      }
      this.addDialog.show = false
      const param = {
        name: cardName
      }
      if (this.addDialog.title === '新建') {
        this.addCardType(param)
      } else if (this.addDialog.title === '编辑') {
        param.id = this.typeId
        this.getChangeCardType(param)
      }
    },

    // 修改卡类型接口
    getChangeCardType (param) {
      this.$http.getChangeCardType(param)
        .then((res) => {
          if (res.status === 200) {
            this.$message.success('修改成功')
            this.searchHandleForm()
          }
        })
    },

    // 添加卡类型接口
    addCardType (param) {
      this.$http.addCardType(param)
        .then((res) => {
          if (res.status === 200) {
            this.$message.success(res.msg)
            this.getItemList()
          }
        })
    },
    getDetail (id) {
      return this.$http.getCardTypeInfo({ id }).then(res => res.data)
    },
    // 获取详情
    async getCardTypeInfo (id) {
      const res = await this.getDetail(id)
      res ? this.cardTypeInfo = res : this.$message.warning('该条信息可能已被删除,请刷新列表')
    },

    init () {
      const _isAdmin = this._isAdmin
      if(!_isAdmin) {
        this.Table.primaryBtn = null
        this.Table.handle = false
      }
      this.getItemList()
      this.getFloorShopList()
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
    this.init()
  }
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.addfrom {
  padding: 0 60px;
}
.head {
  text-align: center;
  > div:first-of-type {
    color: #DD1313;
  }
  > div:last-of-type {
    margin: 15px 0;
    span {
      margin: 0 20px;
    }
  }
}
.input {
  margin: 20px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  .el-input {
    width: 300px;
  }
}
::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}

.content {
    padding: 0 20px;
    .floor {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .floorlist ul{
        margin: 0;
        padding: 0;
      }
      .floorlist li {
        display: inline-block;
        width: 50px;
        cursor: pointer;
        margin-bottom: 10px;
        text-align: center;
      }
      .floorlist li.active{
        color: #5c6be8;
      }
      .el-tabs {
        width: 100%;
      }

    }
    .storeFormat{
      margin-top: 20px;
      span{
        color: #303133;
        padding: 0 5px;
        cursor: pointer;
      }
      .storeName{
        margin-top: 15px;
      }
      .storeFormatActive{
        color: #5c6be8;
      }
    }
    .selectAll {
      margin-top: 20px;
    }
    .el-checkbox {
      width: 25%;
      margin-right: 0;
      &:nth-child(n + 4) {
        margin-top: 20px;
      }
    }
    .selectFloor {
      max-height: 400px;
      overflow: auto;
      margin-top: 20px;
      ::v-deep .el-checkbox__label{
        vertical-align: text-top;
      }
    }
  }

.textOverflow {
  display: inline-block;
  width: 100px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
